import type { ReactElement } from 'react'
import { ImgGlyph } from './ImgGlyph'
import type { GlyphProps } from './shared'

// Base Tadpole silhouette uses the ★1 tier art. The active rendering
// for Spore Tadpole goes through TIERED_GLYPHS (see tieredGlyphs.ts)
// which routes ★2/★3 to the richer tier images extracted from
// assets/spore_tadpole_3tier.jpg.
export const Tadpole = ({ size = 110 }: GlyphProps): ReactElement => (
  <ImgGlyph src="/glyph-assets/tadpole-1.png" size={size} alt="tadpole" />
)
